import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";

const DeleteSurveyQuestionnaireApiService = async (
  request: number
  // eslint-disable-next-line
): Promise<any> => {
  const url = `/formquestions/${request}/`;
  const { data } = await axios.delete(url);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useDeleteSurveyQuestionnaireApiService = () =>
  // eslint-disable-next-line
  useMutation<any, AxiosError, any>(DeleteSurveyQuestionnaireApiService, {
    mutationKey: ["DeleteSurveyApiService"],
  });
export default useDeleteSurveyQuestionnaireApiService;
